let scroll = {
  data() {
    return {
      refScrollContainer: null,
      refScrollImg: null,
    }
  },

  methods: {
    scrolling() {
      let pageTop = window.visualViewport.pageTop
      let startToScroll = this.$refs[this.refScrollContainer].offsetTop - (window.visualViewport.height / 3 * 2)
      let imgHeight = startToScroll + this.$refs[this.refScrollImg].offsetHeight

      if (pageTop > imgHeight) {
        this.$refs[this.refScrollContainer].scrollTop = imgHeight - startToScroll
      } else if (pageTop > startToScroll && pageTop < imgHeight) {
        this.$refs[this.refScrollContainer].scrollTop = pageTop - startToScroll
      } else {
        this.$refs[this.refScrollContainer].scrollTop = pageTop - startToScroll
      }
    }
  }

}

export default scroll;
